import { FormikHelpers } from "formik";
import { useCreateLineType } from "./api/createLineType";
import LineTypeForm from "./LineTypeForm";


const CreateLineType = ({handleCloseModal}: CreateLineTypeProps)  => {
  const createLineTypeMutation = useCreateLineType({data: {}});

  const initialValues: IPostNewLineType = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewLineType, { setSubmitting }: FormikHelpers<IPostNewLineType>): Promise<void> => {
    try {
      await createLineTypeMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <LineTypeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateLineTypeProps {
  handleCloseModal: () => void;
}

export default CreateLineType;